import { Component } from "react";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardHeader";
import CardActions from "@material-ui/core/CardActions";
import Button from "@material-ui/core/Button";

import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import PropTypes from "prop-types";

class SMSTemplatesComponent extends Component {
  render() {
    return (
      <div className="sms-templates-layout">
        {this.props.smsTemplates && this.props.smsTemplates.length > 0 ? (
          <div>
            {this.props.smsTemplates.map((template, index) => {
              return (
                <TemplateComponent
                  smsTemplate={template}
                  setTemplate={this.props.setTemplate}
                  key={index}
                />
              );
            })}
          </div>
        ) : undefined}
      </div>
    );
  }

  static propTypes = {
    smsTemplates: PropTypes.any,
    setTemplate: PropTypes.func.isRequired,
  };
}

class TemplateComponent extends Component {
  constructor(props) {
    super(props);

    var initialTemplateText =
      props.smsTemplate.Template != null ? props.smsTemplate.Template : "";
    var initialTemplateVersion =
      props.smsTemplate.Version != null ? props.smsTemplate.Version : -1;

    this.state = {
      templateText: initialTemplateText,
      templateVersion: initialTemplateVersion,
    };
  }

  changeTemplateText = (event) => {
    this.setState({
      ...this.state,
      templateText: event.target.value,
    });
  };

  changeTemplateVersion = (event) => {
    this.setState({
      ...this.state,
      templateVersion: event.target.value,
    });
  };

  updateTemplate = (templateType) => {
    this.props.setTemplate(
      templateType,
      this.state.templateText,
      this.state.templateVersion,
    );
  };

  render() {
    return (
      <Card>
        <ExpansionPanel>
          <ExpansionPanelSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1c-content"
            id="panel1c-header"
          >
            <CardHeader title={this.props.smsTemplate.Type} />
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <CardActions>
              <Button
                variant="outlined"
                onClick={this.updateTemplate.bind(
                  this,
                  this.props.smsTemplate.Type,
                )}
              >
                Update template
              </Button>
            </CardActions>
            <CardContent>
              <textarea
                value={this.state.templateText}
                onChange={this.changeTemplateText}
              />
              <br />
              <input
                type="number"
                value={this.state.templateVersion}
                onChange={this.changeTemplateVersion}
              />
            </CardContent>
          </ExpansionPanelDetails>
        </ExpansionPanel>
      </Card>
    );
  }

  static propTypes = {
    smsTemplate: PropTypes.object.isRequired,
    setTemplate: PropTypes.func.isRequired,
  };
}

export default SMSTemplatesComponent;
